<template>
    <div class="historico-certificacao">
        <h2 class="historico-certificacao__title">
            {{
                $tc(
                    'certification.messages.certification_analysis',
                    analises.length
                )
            }}
        </h2>
        <div
            class="historico-certificacao__table"
            v-for="(analise, index) in analises"
            :key="`historico-certificacao-${index}`"
            :class="{
                'historico-certificacao__table--active':
                    analise.idAnalise === idAnalise
            }"
            @click="$emit('atualizar', analise.idAnalise)"
        >
            <div class="historico-certificacao__items">
                <div class="historico-certificacao__item">
                    <span class="historico-certificacao__value">{{
                        analise.data
                    }}</span>
                </div>
                <div
                    class="historico-certificacao__item"
                    v-for="(key, index) in listKeys"
                    :key="`historico-certificacao-item-${index}`"
                >
                    <span class="historico-certificacao__label">{{
                        analise[key].label
                    }}</span>
                    <span
                        class="historico-certificacao__value"
                        :class="`historico-certificacao__label--${analise[key].status}`"
                    >
                        {{ analise[key].value }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HistoricoCertificacao',
    components: {},
    props: {
        idAnalise: {
            type: [String, Number],
            default: ''
        },
        historico: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            listKeys: ['2BSvs', 'Proterra', 'RTRS', 'EPA'],
            corStatus: {
                ELEGIVEL: 'success',
                PARCIALMENTE_ELEGIVEL: 'success',
                NAO_SE_APLICA: 'danger',
                INELEGIVEL: 'danger',
                EM_ANALISE: 'normal',
                NAO_ANALISADO: 'normal'
            }
        };
    },
    computed: {
        analises() {
            return this.montarLista(this.historico);
        }
    },
    methods: {
        montarLista(historico) {
            const analises = historico.map(item => {
                const certificacaoTerritorioResultado =
                    item.certificacaoTerritorioResultado;
                const certificacoes = certificacaoTerritorioResultado.filter(
                    key => this.listKeys.includes(key.tipoCertificacaoNome)
                );

                const items = certificacoes.reduce((acc, certificacao) => {
                    const resultadoParcialmenteEleigivel =
                        certificacao.resultadoParcial?.resultadoCodigo === 'ELEGIVEL';
                    const resultadoNome = resultadoParcialmenteEleigivel
                        ? 'Parcialmente elegível'
                        : certificacao.resultadoNome;
                    const resultadoCodigo = resultadoParcialmenteEleigivel
                        ? 'PARCIALMENTE_ELEGIVEL'
                        : certificacao.resultadoCodigo;

                    if (!acc[certificacao.tipoCertificacaoNome]) {
                        return {
                            ...acc,
                            [certificacao.tipoCertificacaoNome]: {
                                label: certificacao.tipoCertificacaoNome,
                                value: resultadoNome,
                                status:
                                    this.corStatus[resultadoCodigo] || 'normal'
                            }
                        };
                    } else {
                        return acc;
                    }
                }, {});

                return {
                    idAnalise: item.idAnalise,
                    data: item.dataAnalise || '--',
                    ...items
                };
            });
            return analises;
        }
    }
};
</script>

<style lang="scss" scoped>
.historico-certificacao {
    &__title {
        font-weight: bold;
        margin: 16px 0;
    }
    &__table {
        display: flex;
        gap: 20px;
        background-color: $white;
        border-radius: $default-border-radius;
        padding: 20px;
        cursor: pointer;
        & + & {
            margin-top: 20px;
        }
        &--active {
            border: 2px solid var(--primary);
            cursor: default;
        }
    }
    &__items {
        display: grid;
        grid-template-columns: 1fr repeat(4, 180px);
        width: 100%;
    }
    &__item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 6px;
        color: var(--primary);
    }
    &__label {
        font-weight: bold;
        font-size: 16px;
        &--success {
            color: var(--green);
        }
        &--danger {
            color: var(--danger);
        }
    }
    &__value {
        font-size: 14px;
    }
}
</style>
